<template>
  <div class="vx-row">
      <vx-card title="USER LIST" v-can:any="['create-user', 'view-user']">
        <template slot="actions">
            <vs-button v-can="'create-user'" @click="onClickCreateUser" class="mr-4" color="primary" type="filled">Create User</vs-button>
        </template>
        <div slot="no-body" class="mt-4">
          <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                    v-model="filters['search']"

                    class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
          <vs-table v-can="'view-user'" :max-items="(meta.per_page) ? meta.per_page : 10" id="users-list"
                    :data="users_list"  @sort="handleSort"  :sst="true" stripe
                    class="table-dark-inverted table-auto vs-con-loading__container">>

            <template slot="thead">
              <vs-th width="20%" sort-key="name">NAME</vs-th>
              <vs-th width="15%" sort-key="email">EMAIL</vs-th>
              <vs-th width="10%" sort-key="contact_1">CONTACT</vs-th>
              <vs-th width="15%">LAST LOGGED IN</vs-th>
              <vs-th width="10%" class="text-center">STATUS</vs-th>
              <vs-th width="10%" class="float-left">ROLE</vs-th>
              <vs-th width="10%">2FA</vs-th>
              <vs-th width="10%" v-can="'edit-user'">ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr  :key="indextr" v-for="(tr, indextr) in data">


                <vs-td :data="data[indextr].name">
                  {{ data[indextr].first_name + ' ' + data[indextr].last_name }}
                </vs-td>

                <vs-td :data="data[indextr].email">
                  {{ data[indextr].email }}
                </vs-td>
                <vs-td :data="data[indextr].mobile">
                  {{ data[indextr].mobile || 'N/A' }}
                </vs-td>

                <vs-td :data="data[indextr].last_login_at">
                  {{__dateTimeFormatter(data[indextr].last_login_at)}}
                </vs-td>

                <vs-td>
                  <vs-chip transparent :color="data[indextr].status.name === 'Active' ? 'primary' : 'danger'">
                    {{ data[indextr].status.name }}
                  </vs-chip>
                </vs-td>

                <vs-td :data="data[indextr].role">
                  {{ !!data[indextr].role ? data[indextr].role.name : ''}}
                </vs-td>

                <vs-td>
                  <vs-chip v-if="data[indextr].is_google_2fa_enable" transparent color="dark">
                    Enabled
                  </vs-chip>
                </vs-td>

                <vs-td v-can="'edit-user'">
                  <div class="vx-row">
                    <vx-tooltip class="mr-2" text="Edit" position="left">
                      <vs-button @click.stop="onClickUserEdit(data[indextr].id)"
                                 size="small" color="primary" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip v-if="!data[indextr].email_verified_at" class="mr-2" text="Resend welcome email" position="left">
                      <vs-button @click.stop="onClickResendWelcomeEmail(data[indextr].email)"
                                 size="small" color="#4AA96C" type="border" icon-pack="feather" icon="icon-refresh-ccw"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>


          </vs-table>
          <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

        </div>
      </vx-card>
    <update-staff-pop-up ref="trackingImages"/>
    <create-staff-pop-up ref="createStaffPopup"/>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
import UpdateStaffPopUp from '@/components/popups/staff/UpdateStaffPopUp'
import CreateStaffPopUp from '@/components/popups/staff/CreateStaffPopUp'
const UserRepository = RepositoryFactory.get('user')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

export default {
  name: 'AllUsersList',
  data () {
    return {
      users_list: [],
      filters: {},
      page : 1,
      total: 0,
      meta : {},
      sort : '',
    }
  },
  components: {
    UpdateStaffPopUp,
    CreateStaffPopUp
  },
  methods: {
    async refreshData () {
      await this.fetchUsersList()
    },
    async onClickUserEdit (id) {
      await this.$refs.trackingImages.openPopup(id)
    },
    async onClickResendWelcomeEmail(email) {
      this.$vs.loading()
      try {
        await UserRepository.resendWelcomeEmail(email)
        this.showSuccessMessage('Email resent successfully')
      }catch (e) {
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async fetchUsersList() {
      await this.$vs.loading({
        container: '#users-list',
        scale: 0.50
      });
      try {
        const {data} = await UserRepository.get(this.page, this.filterQuery, 10, this.sort)
        this.users_list =  data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#users-list > .con-vs-loading')
    },

    async onClickCreateUser () {
      await this.$refs.createStaffPopup.openPopup()
    },

    filterQueryUpdate (){
      this.fetchUsersList()
    },

    handleChangePage(page) {
      this.page=page;
      this.fetchUsersList()
    },

    handleSort(key, active) {
      if(key){
        active = (active==='desc')? "-":'';
        this.sort=active+key;
        this.fetchUsersList()
      }

    }

  },
  watch : {
    page(){
      this.fetchUsersList()
    }
  },
  mixins: [SuccessMessage, ErrorMessages, Filter],
}
</script>


<style scoped>

</style>
